module.exports = __webpack_public_path__ + "img/AU_and_ASU_partnership_lockup.d90e1bc8.png";